export const CONST_NONE_APPEND_WORD = "sfhaitao.xyz!";
export const CONST_DEFAULT_REQUEST_HEADER = {
  _sm: "md5",
};
export const CONST_VD_APPID = 401;
export const CONST_PASSWORD_SLOT = "www.sfht.com";
export const TOKEN_AND_SIGNATURE_ERROR_GROUP = [-360, -300, -180];
// export const CONST_VD_IMGPREFIX = "http://crosscloud-erp-public.oss-cn-hangzhou.aliyuncs.com/";
export const CONST_VD_IMGPREFIX = {
  prefixImgUrl: "com.sfebiz.user.dynamic.config",
  env: "dev",
};
export const platformInfo = {};
export const CONST_VD_FILEPREFIX =
  "http://crosscloud-image-public.oss-cn-hangzhou.aliyuncs.com/";
export const CONST_VD_API_REQUEST_URL = "http://vd.oceanz.cn";
export const CONST_CMS_REQUEST_URL_FILE = "http://vd.oceanz.cn/file.api";
export const CONST_CMS_REQUEST_URL_FILE_NEW = "http://vd.oceanz.cn/nfile.api";

// 不需要权限的页面名称
export const CONST_NO_TOKEN_PAGE = [
  "index",
  "cooperate",
  "serve",
  "dynamic",
  "m_index",
  "m_cooperate",
  "m_serve",
  "m_dynamic",
];

// cds订单导入模板
export const CONST_IMPORT_ORDER_TEMPLATE_URL =
  process.env.BASE_URL + "templates/订单申报模板.xlsx";
// 商品申报导入模板
export const CONST_IMPORT_DECLARE_GOODS_TEMPLATE_URL =
  process.env.BASE_URL + "templates/商品备案模板.xlsx";
// 采购单导入模板
export const CONST_IMPORT_PURCHASE_TEMPLATE_URL =
  process.env.BASE_URL + "templates/采购单导入2.xlsx";
// 核注单导入模板
export const CONST_IMPORT_HE_ZHU_TEMPLATE_URL =
  process.env.BASE_URL + "templates/核注单导入模板1.xlsx";

// 出库单导入商品模板
export const CONST_IMPORT_OUTBOUND_SKU_TEMPLATE_URL =
  process.env.BASE_URL + "templates/出库单导入商品模板.xlsx";

// 海关币制：下拉展示中文名，提交/核注 curr 用编码
export const CUSTOMS_CURRENCY_OPTIONS = [
  { value: "110", label: "港币" },
  { value: "112", label: "印度尼西亚卢比" },
  { value: "116", label: "日本元" },
  { value: "121", label: "澳门元" },
  { value: "122", label: "马来西亚林吉特" },
  { value: "129", label: "菲律宾比索" },
  { value: "132", label: "新加坡元" },
  { value: "133", label: "韩国圆" },
  { value: "136", label: "泰国铢" },
  { value: "142", label: "人民币" },
  { value: "143", label: "新台币" },
  { value: "300", label: "欧元" },
  { value: "302", label: "丹麦克朗" },
  { value: "303", label: "英镑" },
  { value: "326", label: "挪威克朗" },
  { value: "330", label: "瑞典克朗" },
  { value: "331", label: "瑞士法郎" },
  { value: "344", label: "俄罗斯卢布" },
  { value: "501", label: "加拿大元" },
  { value: "502", label: "美元" },
  { value: "601", label: "澳大利亚元" },
  { value: "609", label: "新西兰元" },
];

export function customsCurrencyName(code) {
  const item = CUSTOMS_CURRENCY_OPTIONS.find((option) => option.value === code);
  return item ? item.label : "";
}
